export default __webpack_public_path__ + "static/media/teaser_03.52dc8515.png";